module.exports = "./img/c249c98a8bd30aa7f150d9189ac6c162.jpg";